/**
 * Public social proof figures for marketing pages.
 * Update when verifiable milestones change.
 */
export const SOCIAL_PROOF = {
  users: {
    value: "2,000+",
    shortLabel: "Owners & shops",
    longLabel: "Car owners, buyers, and wheel shops",
  },
  previews: {
    value: "10,000+",
    shortLabel: "Previews created",
    longLabel: "AI wheel previews generated",
  },
  speed: {
    value: "<60s",
    shortLabel: "Per preview",
    longLabel: "Average time from upload to result",
  },
} as const;
